<ng-template #navItem let-item>
  <li [paiCmsId]="item">
    @switch (item.__typename) {
      @case ('NavigationParentItem') {
        <button
          class="mobile-nav__menu-link mobile-nav__menu-link--sub"
          paiRipple
          type="button"
          (click)="toggleSubNav(item)"
          [attr.aria-controls]="'submenu_' + item.id"
          [attr.aria-expanded]="isOpen(item)"
        >
          <span>{{ item.label }}</span>
          <pai-switching-chevron class="mobile-nav__menu-link-arrow" [pointingDown]="!isOpen(item)" />
        </button>
        @if (isOpen(item)) {
          <ul class="mobile-nav__menu mobile-nav__menu--sub" @subList [attr.id]="'submenu_' + item.id">
            @for (subItem of item.items; track subItem) {
              <li [paiCmsId]="subItem" @subListItem>
                <a
                  class="mobile-nav__menu-link"
                  [paiCmsLink]="subItem.target"
                  paiCmsLinkActive="mobile-nav__menu-link--active"
                  (click)="closeSubNav(item)"
                  paiRipple
                >
                  <span>{{ subItem.label }}</span>
                </a>
              </li>
            }
          </ul>
        }
      }
      @case ('NavigationItem') {
        <a
          class="mobile-nav__menu-link"
          [paiCmsLink]="item.target"
          paiRipple
          paiCmsLinkActive="mobile-nav__menu-link--active"
        >
          <span>{{ item.label }}</span>
        </a>
      }
    }
  </li>
</ng-template>

<div class="mobile-nav" #scrollContainerRef>
  <ul class="mobile-nav__menu">
    @for (item of header.navigationItems; track item) {
      <ng-container [ngTemplateOutlet]="navItem" [ngTemplateOutletContext]="{ $implicit: item }" />
    }
    @for (item of header.cta; track item) {
      <ng-container [ngTemplateOutlet]="navItem" [ngTemplateOutletContext]="{ $implicit: item }" />
    }
  </ul>
  <div class="mobile-nav__bottom">
    @if (languages$ | async; as languages) {
      <ul class="mobile-nav__lang-selection">
        @for (lang of languages; track lang) {
          <li [paiCmsId]="lang">
            <a
              class="mobile-nav__lang-selection-link"
              [class.mobile-nav__lang-selection-link--selected]="lang.selected"
              paiRipple
              [attr.title]="lang.label"
              [attr.aria-label]="lang.label"
              [attr.hreflang]="lang.abbr"
              [attr.href]="lang.altUrl"
            >
              <span>{{ lang.abbr | uppercase }}</span>
            </a>
          </li>
        }
      </ul>
    }
    <ul class="mobile-nav__social-links">
      @for (link of footer.socialLinks; track link) {
        <li [paiCmsId]="link">
          <a
            class="mobile-nav__social-link-item"
            [href]="link.url"
            [attr.aria-label]="link.label"
            [paiIconButton]="link.icon && link.icon.url ? link.icon.url : ''"
            size="small"
            appearance="primary"
          ></a>
        </li>
      }
    </ul>
  </div>
</div>
